import { UserInfo } from "../interfaces/authentication";
import { get } from "./util";

export async function getUserInfo() {
  return get<UserInfo>({
    query: "User/userinfo",
    skipAuthRedirect: true,
  });
}
